import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/putting-greens/hero.webp'
import _imports_1 from '@/assets/putting-greens/g-1.webp'
import _imports_2 from '@/assets/putting-greens/g-2.webp'
import _imports_3 from '@/assets/putting-greens/g-3.webp'
import _imports_4 from '@/assets/putting-greens/g-4.webp'
import _imports_5 from '@/assets/putting-greens/g-5.webp'
import _imports_6 from '@/assets/putting-greens/g-6.webp'
import _imports_7 from '@/assets/putting-greens/g-7.webp'
import _imports_8 from '@/assets/putting-greens/g-8.webp'
import _imports_9 from '@/assets/grass-wide.webp'


const _hoisted_1 = { class: "flex flex-col mx-auto gap-y-16 md:gap-y-32 max-w-ful overflow-x-hidden" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col gap-10 md:gap-4 lg:gap-10 md:flex-row items-centerw-full max-w-full md:max-w-[95%] lg:max-w-[1120px] mx-auto mt-10 md:mt-20 px-7 md:px-0\"><img src=\"" + _imports_0 + "\" class=\"md:hidden\"><div class=\"md:max-w-[320px] lg:max-w-[360px] flex flex-col gap-6\"><div class=\"font-bold text-[32px] md:text-[52px] text-secondary-gray md:text-green leading-tight font-georgian\"> The Perfect Putting Green </div><div class=\"text-sm leading-relaxed\"><span class=\"text-light-green font-bold\">Imagine having your own putting green right in your own back yard</span><br><br><span class=\"text-primary-gray\"> ProGreen Canada is Most Trusted Artificial Turf unlike turf manufactured overseas, which is often of poor quality and may contain lead or other heavy metals. Be confident that ProGreen Synthetic Turf Systems is <span class=\"text-light-green font-bold\">100% lead </span>and <span class=\"text-light-green font-bold\">heavy metal-free</span> and manufactured using the industry&#39;s highest quality standards. </span></div></div><div class=\"ml-auto w-full max-w-[670px] hidden md:block\"><img src=\"" + _imports_0 + "\"></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-light-green font-bold" }, "“Drive for show, putt for dough”", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-light-green font-bold" }, " “Since I’ve had my own backyard putting green, I’ve cut six strokes off my handicap. I try to practice 10 minutes every day on my chipping and putting.”", -1)
const _hoisted_5 = { class: "hidden md:block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-light-green font-bold" }, "“Drive for show, putt for dough”", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-light-green font-bold" }, " “Since I’ve had my own backyard putting green, I’ve cut six strokes off my handicap. I try to practice 10 minutes every day on my chipping and putting.”", -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center gap-6 md:gap-10\"><div class=\"md:uppercase font-bold font-georgian text-2xl md:text-[42px] text-green\"> Our Work </div><div class=\"grid grid-cols-2 md:grid-cols-4 gap-1\"><img src=\"" + _imports_1 + "\" class=\"transition-all hover:scale-105 cursor-pointer hidden md:block\"><img src=\"" + _imports_2 + "\"><img src=\"" + _imports_3 + "\"><img src=\"" + _imports_4 + "\"><img src=\"" + _imports_5 + "\"><img src=\"" + _imports_6 + "\"><img src=\"" + _imports_7 + "\" class=\"transition-all hover:scale-105 cursor-pointer hidden md:block\"><img src=\"" + _imports_8 + "\"></div></div>", 1)
const _hoisted_9 = { class: "relative w-full max-w-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 bottom-0 left-0 right-0 items-center z-0 hidden md:flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    class: "w-full h-60"
  })
], -1)
const _hoisted_11 = { class: "flex flex-col items-center gap-10 z-10 relative max-w-full" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl text-green md:text-[32px] leading-normal font-bold font-georgian text-center" }, [
  /*#__PURE__*/_createTextVNode(" Our most popular "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("putting green solutions ")
], -1)
const _hoisted_13 = { class: "flex gap-4 flex-wrap items-center justify-center" }

import TaggedWidget from "@/components/common/tagged-wedget.vue";
import SolutionCard from "@/components/family-space/solution-card.vue";
import GrassBgMobile from "@/components/common/grass-bg-mobile.vue";
// import FilledButton from "@/components/common/filled-button.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PuttingGreens',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GrassBgMobile, { class: "md:hidden" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createTextVNode(" is the age-old adage that suggests that the game of golf is won on the putting green. If you’re interested in improving your short game, you should look into having a putting green right in your own backyard. A ProGreen low maintenance putting green turf system makes practicing your putting much easier and convenient. Instead of weekly putting green practice, you could find time every day to work on your short game. Take it from the ProGreen founder Steve Walker: "),
        _hoisted_4
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TaggedWidget, null, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(" is the age-old adage that suggests that the game of golf is won on the putting green. If you’re interested in improving your short game, you should look into having a putting green right in your own backyard. A ProGreen low maintenance putting green turf system makes practicing your putting much easier and convenient. Instead of weekly putting green practice, you could find time every day to work on your short game. Take it from the ProGreen founder Steve Walker: "),
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(SolutionCard, { size: "xs" }, {
            title: _withCtx(() => [
              _createTextVNode("PG38")
            ]),
            price: _withCtx(() => [
              _createTextVNode("$8.50")
            ]),
            height: _withCtx(() => [
              _createTextVNode("0.5”")
            ]),
            weight: _withCtx(() => [
              _createTextVNode("38 oz")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" ProGreen PG38 - the premier choice for a high-performance putting green turf. With a precise pile height of 0.5 inches and a weight of 38 ounces, this turf is designed to offer a faster and smoother playing surface. ")
            ]),
            _: 1
          }),
          _createVNode(SolutionCard, { size: "xs" }, {
            title: _withCtx(() => [
              _createTextVNode("PG Augusta")
            ]),
            price: _withCtx(() => [
              _createTextVNode("$8.50")
            ]),
            height: _withCtx(() => [
              _createTextVNode("0.5625”")
            ]),
            weight: _withCtx(() => [
              _createTextVNode("65 oz")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" ProGreen PG Augusta - the ultimate putting green turf designed for golf enthusiasts. With a precise pile height of 0.5 inches and a weight of 60 ounces, this turf offers the perfect balance of smoothness and resilience for an optimal putting experience. ")
            ]),
            _: 1
          })
        ])
      ]),
      _createTextVNode(" > ")
    ])
  ]))
}
}

})